import styled from "styled-components";

// dls
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { CardContainer } from "@swiggy-private/dls-web-core/dist/components/CardContainer";
import { GenericIcon } from "@swiggy-private/dls-web-icons/dist/GenericIconWeb";

const ICON_WRAPPER_HEIGHT = "19px";
const ICON_WRAPPER_WIDTH = "19px";

export const Container = styled.div(({ theme }) => {
    return {
        backgroundColor: theme.colors[theme.colorMode].background_Button_Tertiary_Low,
        paddingBottom: theme.spacing.medium,
    };
});

export const StyledHeading = styled(Text)(({ theme }) => {
    return {
        padding: `calc(2*${theme.spacing.medium}) 0 0 ${theme.spacing.medium}`,
    };
});

export const StyledCardContainer = styled(CardContainer)(({ theme }) => {
    return {
        margin: `${theme.spacing.medium}`,
    };
});

export const ViewUnavailableRewardsCtaContainer = styled.div(({ theme }) => {
    return {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: `${theme.spacing.large} ${theme.spacing.medium}`,
    };
});

export const IconWrapper = styled.div(() => {
    return {
        width: ICON_WRAPPER_WIDTH,
        height: ICON_WRAPPER_HEIGHT,
    };
});

export const Icon = styled(GenericIcon)(() => {
    return {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
    };
});
